import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { RootState } from '../../../redux/store';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import ColumnChooser from '../../../components/ColumnChooser';
import ExcelExportMenu from '../../../components/ExcelExportMenu';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { MUTABAKAT_SAYFASI, MutabakatCalismasi, YurticiMutabakatService } from '../../../services/YurticiMutabakatService';

interface CalismaIstegi {
    skip: number
    take: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
    ids?: string[]
}

const SONUC_RENGI: { [sonuc: string]: string } = { 'Başarılı': 'success', 'Başarısız': 'danger', 'Sürüyor': 'info' };

/**
 * Kargo Modülü > Yurtiçi Kargo > Gider Mutabakatı > Çalışma Geçmişi (24.10.2026, #485): mail raporu okuma (her saat) ve
 * karşılaştırma (her gece + "Şimdi çalıştır") çalışmaları; sonuç, aktarılan gönderi, durum adetleri ve hata metni.
 */
const YurticiMutabakatGecmis = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = MUTABAKAT_SAYFASI
    const sayfaAnahtari = pageName + " > Geçmiş";
    const pageVersion = "1";
    const [data, setData] = useState<{ list: MutabakatCalismasi[], totalRecordCount: number }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<CalismaIstegi>({ skip: 0, take: 50, currentPage: 1, columnChooser: undefined, columnFilters: [] })
    const [calisiyor, setCalisiyor] = useState<boolean>(false);
    const guncelleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canUpdate;

    const getColumns = () => {
        var str = localStorage.getItem(sayfaAnahtari + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Başlangıç', name: 'baslamaZamaniStr', order: 0, isVisible: true },
            { title: 'Bitiş', name: 'bitisZamaniStr', order: 0, isVisible: true },
            { title: 'Tür', name: 'turAdi', order: 0, isVisible: true },
            { title: 'Tetikleyen', name: 'tetikleyenAdi', order: 0, isVisible: true },
            { title: 'Sonuç', name: 'sonucAdi', order: 0, isVisible: true },
            { title: 'Okunan Mail', name: 'okunanMail', order: 0, isVisible: true },
            { title: 'Rapor Dosyası', name: 'dosyaAdlari', order: 0, isVisible: true },
            { title: 'Aktarılan Satır', name: 'aktarilanSatir', order: 0, isVisible: true },
            { title: 'Eşleşen', name: 'eslesen', order: 0, isVisible: true },
            { title: 'Tutar Farklı', name: 'tutarFarkli', order: 0, isVisible: true },
            { title: "Keylogx'te Yok", name: 'keylogxteYok', order: 0, isVisible: true },
            { title: 'Beklenen Gider Yok', name: 'beklenenGiderYok', order: 0, isVisible: false },
            { title: 'Raporda Yok', name: 'rapordaYok', order: 0, isVisible: true },
            { title: 'Ayrı Sınıf', name: 'ayriSinif', order: 0, isVisible: false },
            { title: 'Mesaj', name: 'mesaj', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const lastRequestNo = useRef(0);

    const getData = async (_filter: CalismaIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await YurticiMutabakatService.calismaListesi(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YurticiMutabakatService.calismaExport(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Çalışırken buton pasif; bitince liste yenilenir.
    const simdiCalistir = async () => {
        try {
            setCalisiyor(true);
            dispatch(storeActivityIndicator(true))

            var response = await YurticiMutabakatService.simdiCalistir();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            toast.success('Mutabakat çalıştırıldı.')
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            setCalisiyor(false);
            dispatch(storeActivityIndicator(false))
            getData();
        }
    }

    const sortableColumns = ['baslamaZamaniStr', 'turAdi', 'sonucAdi', 'aktarilanSatir', 'tutarFarkli'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        baslamaZamaniStr: { type: 'date' },
        turAdi: { type: 'text' },
        tetikleyenAdi: { type: 'text' },
        sonucAdi: { type: 'text' },
        dosyaAdlari: { type: 'text' },
        aktarilanSatir: { type: 'number' },
        tutarFarkli: { type: 'number' },
        keylogxteYok: { type: 'number' },
        rapordaYok: { type: 'number' },
        mesaj: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: MutabakatCalismasi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger: any = item2[column];

        if (column == 'sonucAdi')
            deger = <span className={`badge badge-light-${SONUC_RENGI[item.sonucAdi] ?? 'secondary'}`}>{item.sonucAdi}</span>;
        else if (column == 'tutarFarkli' || column == 'keylogxteYok')
            deger = deger > 0 ? <span className="text-danger fw-bold">{deger}</span> : deger;
        else if (column == 'mesaj')
            deger = <span style={{ whiteSpace: 'normal' }}>{item.mesaj}</span>;

        return <td className={className}>{deger}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <div style={{ flex: 1 }}></div>

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={sayfaAnahtari} pageVersion={pageVersion} setColumns={setColumns} />

                <ExcelExportMenu pageName={pageName} selectedCount={0} onExport={excelExport} />

                <div className='m-0'>
                    <a onClick={() => navigate('/yurticimutabakat/list')} className='btn btn-sm fw-bold btn-light-primary'>Mutabakat</a>
                </div>

                {
                    guncelleyebilir && (
                        <button disabled={calisiyor} onClick={simdiCalistir} className='btn btn-sm fw-bold btn-primary'>
                            {calisiyor ? 'Çalışıyor…' : 'Şimdi çalıştır'}
                        </button>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName + ' > ',
                isActive: false,
                path: ''
            }]}>Çalışma Geçmişi</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.yurticiMutabakatCalismasiId}>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={0}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default YurticiMutabakatGecmis;
